module.exports = __webpack_public_path__ + "static/media/the-edit.2bbdb65d.webp";